import { SET_TRANSACTION_HISTORY, SET_FETCH_TRANSACTION } from './action'

const initialState = {
  transactionHistory: {},
  fetchTransaction: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TRANSACTION_HISTORY:
      return {
        ...state,
        transactionHistory: action.data,
      }

    case SET_FETCH_TRANSACTION:
      return {
        ...state,
        fetchTransaction: action.data,
      }

    default:
      return state
  }
}
